import { Star } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { TESTIMONIALS } from "@/data/content";

export const Testimonials = () => (
  <section id="testimonials" className="py-24 sm:py-32" data-testid="testimonials">
    <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
      <Reveal>
        <p className="text-xs uppercase tracking-[0.22em] font-bold text-forest mb-4">Client stories</p>
        <h2 className="text-4xl sm:text-5xl font-extrabold tracking-tighter text-ink max-w-2xl leading-[1.05]">
          Real claims. Real recoveries.
        </h2>
        <p className="mt-3 text-sm text-zinc-400">Representative, anonymised experiences shown while we onboard verified client testimonials.</p>
      </Reveal>

      <div className="mt-14 grid md:grid-cols-2 gap-8">
        {TESTIMONIALS.map((t, i) => (
          <Reveal key={i} delay={i * 0.1}>
            {t.placeholder ? (
              <figure className="h-full rounded-3xl p-8 sm:p-10 border border-dashed border-zinc-300 bg-zinc-50 flex flex-col justify-center min-h-[220px]" data-testid={`testimonial-placeholder-${i}`}>
                <span className="inline-flex self-start items-center gap-2 rounded-full bg-white border border-zinc-200 px-3 py-1 text-xs font-semibold text-zinc-500">
                  <span className="h-2 w-2 rounded-full bg-forest" /> {t.category}
                </span>
                <p className="mt-5 text-lg font-medium tracking-tight text-zinc-500 leading-snug">
                  A verified {t.category} claim review will be published here soon.
                </p>
                <p className="mt-3 text-xs text-zinc-400">Awaiting verified client review</p>
              </figure>
            ) : (
              <figure className="h-full bg-white rounded-3xl p-8 sm:p-10 border border-zinc-200 flex flex-col" data-testid={`testimonial-${i}`}>
                <div className="flex gap-1 mb-6">
                  {[...Array(5)].map((_, s) => <Star key={s} size={18} className="fill-forest text-forest" />)}
                </div>
                <blockquote className="text-xl sm:text-2xl font-medium tracking-tight text-ink leading-snug flex-1">
                  "{t.quote}"
                </blockquote>
                <figcaption className="mt-8 flex items-center gap-4">
                  <img src={t.image} alt={t.name} loading="lazy" className="h-12 w-12 rounded-full object-cover" />
                  <div>
                    <div className="font-bold text-ink">{t.name}</div>
                    <div className="text-sm text-zinc-500">{t.role}</div>
                  </div>
                </figcaption>
              </figure>
            )}
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default Testimonials;
